/**
 * Catálogo central de endpoints da API Audio Vertical.
 * Portado do environment.ts do audio_vertical_app (plano de unificação, §3).
 * Caminhos relativos à raiz do backend (environment.baseUrl).
 */
export const API_ENDPOINTS = {
  login: "auth/token/",
  revokeToken: "auth/revoke_token/",
  userLogged: "api/users/me/",
  hasProfile: "api/profile/me/",
  resetPassword: "api/password_reset/",
  confirmPassword: "api/password_reset/confirm/",
  validateToken: "api/password_reset/validate_token/",
  register: "api/registration/new/",
  confirmEmail: "api/registration/confirm/",
  sendEmail: "api/send_email/",
  categories: "api/categories/",
  genres: "api/categories/?category_type=3",
  measure: "api/measures/",
  payment_methods: "api/payments_methods/",
  speciality_by_parent: "api/categories/?category_type=2&parent=",
  category_by_profile: "api/profile_categories/?id=",
  profile: "api/profile/",
  profiles: "api/profiles/",
  users: "api/users/",
  search_profiles: "api/profile/ordering/",
  update_user: "api/update_user/",
  update_user_photo: "api/my/photo/",
  limits_price: "api/limits_price/?id=",
  search_main: "api/profile/name/?q=",
  profile_update: "api/profile/me/update/",
  create_relationship: "api/message_buckets/my/",
  send_message: "api/send_message/",
  get_bucket: "api/my/message_buckets/",
  list_chat: "api/message_bucket/messages/",
  send_offer: "api/works/",
  my_hires: "api/my/hires/",
  my_offers: "api/my/offers/",
  my_works: "api/my/works/",
  my_messages: "api/messages/unread/",
  favourites: "api/favourites/",
  hire_by_id: "api/new/offers/",
  indication: "api/indication/",
  indication_link: "api/indication/link/",
  contract_no_offer: "api/accept/works/",
  api_offers: "api/offers/",
  finally_hire: "api/works/",
  payment: "api/pagarme/payments/",
  finish: "api/finish/works/",
  execution: "api/execution/works/",
  receiver: "api/receiver/works/",
  payment_resume: "api/payment/resume/",
  list_cards: "api/pagarme/create_card/",
  bin: "api/bin/",
  pagarme: "api/pagarme/",
  recebedor: "api/pagarme/criar-recebedor/",
  recebedor_cnpj: "api/pagarme/criar-recebedor/cnpj/",
  atualizar_conta_bancaria: "api/pagarme/update_account_bank/",
  atualizar_conta_bancaria_cnpj: "api/pagarme/update_account_bank/cnpj/",
  cepbusca: "/api/cep/v1/",
  endereco: "api/address/",
  cidadesMundo: "api/world-cities/",
  codigoPostal: "api/postal-code/",
  customer_id: "api/pagarme/list_clients/",
  banks: "api/info_banks/",
  delete_card: "api/pagarme/delete_card/",
  alter_password: "api/change_password/",
  request_reset_email: "api/request-reset-email/",
  rating: "api/rating/stars/",
  extract_balance: "api/user/extract/balance/",
  get_alerts: "api/user/alerts/",
  get_not_read_alerts: "api/user/count/alerts/",
  register_device_token: "api/user/device-token/",
  withdraw: "api/user/pagarme/withdraw/",
  cities: "api/cities/",
  profiles_rs: "api/banner_rs/",
  generate_pix_code: "api/pagarme/payments/pix/",
  confirm_pix_payment: "api/pagarme/payments/pay_pix/",
  reject_work: "api/reject-work/works/",
  not_receive_work: "api/not_receive-work/works/",
  check_android: "api/check-version/android/",
  check_ios: "api/check-version/ios/",
  expiredToken: "api/validate-token/",
  status_pix_payment: "api/pix-status/",
  // Prova de vida / KYC do recebedor (Pagar.me/Stone). O link expira em
  // 20 min do lado da Pagar.me, então é sempre gerado sob demanda.
  kyc_link: "api/kyc/",
  kyc_status: "api/kyc/status/",
} as const;

/** Diretório de download usado pelo Filesystem no Android (visual app). */
export const FILESYSTEM_DOWNLOAD_DIR = "file:///storage/emulated/0/Download/";
